/** Libellés de la barre Mantine Tiptap, communs à la bubble et à la sidebar. */
export const RICH_TEXT_LABELS = {
  linkControlLabel: 'Ajouter un lien',
  unlinkControlLabel: 'Retirer le lien',
  linkEditorSave: 'Enregistrer',
  linkEditorInputPlaceholder: 'https://exemple.com',
  linkEditorInputLabel: 'Adresse du lien',
  linkEditorExternalLink: 'Ouvrir dans un nouvel onglet',
  linkEditorInternalLink: 'Ouvrir dans le même onglet',
};
